
import { Link } from 'react-router-dom';
import { useStyle } from '../../context/styleContext/styleContext';

const footerLinks = [
  { label: 'Plugins', to: '/products' },
  { label: 'Support', to: '/support' },
  { label: 'Contact', to: '/contact' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms', to: '/terms' },
];

export default function Footer() {
  const { style } = useStyle();

  const startYear = 2025;
  const curYear = new Date().getFullYear();

  const yearDisplayString =
    startYear === curYear
      ? `${startYear}`
      : `${startYear} - ${curYear}`;

  return (
    <footer
      style={{
        marginTop: 'auto',
        width: '100%',
        flexShrink: 0,
        boxSizing: 'border-box',
        backgroundColor: style.color1,
        color: style.color4,
        borderTop: `1px solid ${style.color2}`,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            padding: '18px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <nav
            aria-label="Footer navigation"
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              columnGap: '18px',
              rowGap: '6px',
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            {footerLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                style={{
                  display: 'inline-block',
                  color: style.color4,
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  lineHeight: 1.5,
                  opacity: 0.92,
                  whiteSpace: 'nowrap',
                }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <p
            style={{
              margin: 0,
              padding: 0,
              color: style.color3,
              fontSize: '0.88rem',
              lineHeight: 1.5,
              fontWeight: 400,
              textAlign: 'center',
            }}
          >
            &copy; {yearDisplayString} Parish Audio
            {' '}— All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}


// import { Link } from 'react-router-dom';
// import { useStyle } from '../../context/styleContext/styleContext';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Stack from '@mui/material/Stack';
// import Typography from '@mui/material/Typography';

// export default function Footer() {
//   const { style } = useStyle();

//   const startYear = 2025;
//   const curYear = new Date().getFullYear();
//   const yearDisplayString =
//     startYear === curYear ? `${startYear}` : `${startYear} - ${curYear}`;

//   const footerLinks = [
//     { label: 'Plugins', to: '/products' },
//     { label: 'Support', to: '/support' },
//     { label: 'Contact', to: '/contact' },
//     { label: 'Privacy Policy', to: '/privacy-policy' },
//     { label: 'Terms', to: '/terms' },
//   ];

//   return (
//     <Box
//       component="footer"
//       sx={{
//         mt: 'auto',
//         width: '100%',
//         backgroundColor: style.color1,
//         color: style.color4,
//         borderTop: `1px solid ${style.color2}`,
//       }}
//     >
//       <Container maxWidth="lg">
//         <Box
//           sx={{
//             py: 2.25,
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             gap: 1.25,
//           }}
//         >
//           <Stack
//             direction="row"
//             useFlexGap
//             flexWrap="wrap"
//             justifyContent="center"
//             spacing={0}
//             sx={{ rowGap: 0.75, columnGap: 2.25 }}
//           >
//             {footerLinks.map((link) => (
//               <Link
//                 key={link.to}
//                 to={link.to}
//                 style={{
//                   color: style.color4,
//                   textDecoration: 'none',
//                   fontWeight: 600,
//                   fontSize: '0.95rem',
//                   opacity: 0.92,
//                 }}
//               >
//                 {link.label}
//               </Link>
//             ))}
//           </Stack>

//           <Typography
//             sx={{
//               fontSize: '0.88rem',
//               color: style.color3,
//               textAlign: 'center',
//             }}
//           >
//             &copy; {yearDisplayString} Parish Audio — All rights reserved.
//           </Typography>
//         </Box>
//       </Container>
//     </Box>
//   );
// }
// // import {useNavigate, Link} from 'react-router-dom';
// // import { useStyle } from '../../context/styleContext/styleContext';

// // export default function Footer(){

// //     const { style, setStyle } = useStyle();
// //     var yearDisplayString = ""
// //     const startYear = '2025'
// //     const curDateTime = new Date()
// //     const curYear = curDateTime.getFullYear()
    
// //     if(startYear == curYear)
// //         {
// //             yearDisplayString = startYear + " - "
// //         }
// //     else
// //         {
// //             yearDisplayString = startYear + " - " + curYear
// //         }


// //     return (
// //     <>
// //     <footer className="footer" style={{backgroundColor:style.color1, color:style.color4, width:'100%', marginBottom:'0px'}}>
// //         <div style={{margin:'auto', width:'90%', textAlign:'center', padding:'5px'}}>
// //             <div style={{marginTop:'10px'}}>
// //             <Link to='/' style={{className:'headerLinkText', fontSize:'1.0rem', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Home</Link>
// //             <Link to='/plugins' style={{fontSize:'1.0rem', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Plugins</Link>
// //             <Link to='/support' style={{fontSize:'1.0rem', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Support</Link>
// //             <Link to='/privacy-policy' style={{fontSize:'1.0rem', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Privacy Policy</Link>
// //             <Link to='/contact' style={{fontSize:'1.0rem', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Contact</Link>
// //             </div>
// //             <div style={{marginTop:'10px'}}>
// //             <Link to='/about' style={{fontSize:'1.0rem', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>About</Link>
// //             <Link to='/faq' style={{fontSize:'1.0rem', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>FAQ</Link>
// //             <Link to='/learning' style={{fontSize:'1.0rem', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Learn</Link>
// //             <Link to='/terms' style={{fontSize:'1.0rem', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Terms & Conditions</Link>
// //             <Link to='/return-policy' style={{fontSize:'1.0rem', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'5px', marginRight:'5px', marginTop:'10px', marginBottom:'10px', color:style.color4}}>Return Policy</Link>
// //             </div>
// //             <p style={{marginTop:'10px', marginBottom:'0px'}}>&copy; {yearDisplayString} Parish Audio -  All rights reserved.</p>
// //         </div>  


// //     </footer>
    
// //     </>)
// // }
